module.exports = __webpack_public_path__ + "static/media/close.33c81e1d.svg";